module.exports = __webpack_public_path__ + "img/2-2.015b9a59.svg";